import { GET_USER_FLAGS, GET_USER_FLAGS_DONE, GET_USER_FLAGS_ERROR, HERO_ONLINE } from './actionTypes';
const initialState = {
    data: {},
    isLoading: false,
    error: false,
    errorMessage: null
};
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_USER_FLAGS:
            return Object.assign(Object.assign({}, state), { isLoading: true });
        case GET_USER_FLAGS_DONE:
            return Object.assign(Object.assign({}, state), { data: Object.assign({}, action.data), isLoading: false, error: false, errorMessage: null, lastTimeRetrieved: Date.now() });
        case GET_USER_FLAGS_ERROR:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: true, errorMessage: action.data.msg });
        case HERO_ONLINE:
            return Object.assign(Object.assign({}, state), { data: Object.assign(Object.assign({}, state.data), { hero_offline: false, in_travel_mode: false }) });
        default:
            return state;
    }
};
export default reducer;
//# sourceMappingURL=reducer.js.map